import {IntegrationAuthorization} from './IntegrationDesign';
import {integrationActions} from "../../../store/actions/integrationAction";
import {connect} from "react-redux";
import {useEffect} from "react";

function TikTokLoginRedirect({history, integration, getTikTokLoginLink, alert}) {
    useEffect(() => {
        if (integration.selectedIntegration.name === "TikTok") {
            getTikTokLoginLink();
        }
    }, [getTikTokLoginLink, integration?.selectedIntegration?.name]);

    useEffect(() => {
        if (integration?.tiktok?.loginLink !== null) {
            document.location.href = integration?.tiktok?.loginLink;
        }
    }, [integration?.tiktok?.loginLink])

    useEffect(() => {
        if (alert.errorMsg !== "") {
            history.push({pathname: "/settings/integrations"});
        }
    }, [history, alert?.errorMsg])

    return <IntegrationAuthorization name="TikTok"/>;
}

const mapStateToProps = (state) => {
    return {
        integration: state.integration,
        alert: state.alert
    };
};

const mapDispatchToProps = {
    getTikTokLoginLink: integrationActions.getTikTokLoginLink
};

export default connect(mapStateToProps, mapDispatchToProps)(TikTokLoginRedirect);
